import lodash from "lodash";
import i18n from "../../i18n";
import store from "../../store";
import { createButtonCreate } from "../../utils/button";
import { conditionFormChecker, onClickDeleteAllClient } from "../../utils/form";
import { createLoading } from "../../utils/loading";
import { createManageDelete, createManageExportCsv, createPage } from "../../utils/page";
import {
    createColumnInlineAttachment,
    createColumnInlineInput,
    createColumnInlineTextArea
} from "../table/c-table.logic";

export const { isLoading, setIsLoading } = createLoading();

export const actionPrefix = "resource/v1/master/attachment";

export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria });

export const createColumns = ({ props, data }) => {
    const { viewOnly, itemsKey, group, inputTextType } = props;

    const { useForm } = data;
    const { modelRef } = useForm;
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    const columns = [];
    if (inputTextType == 'textArea') {
        columns.push(createColumnInlineTextArea({
            title: () => i18n.global.t("model.attachment.documentName"),
            dataIndex: "documentName",
            items,
            useForm,
            itemsKey,
            customRenderInputProp: ({ record, key }) =>
                lodash.merge(
                    { disabled: viewOnly || record.attribute?.isDisabledDocumentName },
                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key } } })
                ),
            search: { visible: () => false }
        }))
    } else {
        columns.push(
            createColumnInlineInput({
                title: () => i18n.global.t("model.attachment.documentName"),
                dataIndex: "documentName",
                items,
                useForm,
                itemsKey,
                customRenderInputProp: ({ record, key }) =>
                    lodash.merge(
                        { disabled: viewOnly || record.attribute?.isDisabledDocumentName },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key } } })
                    ),
                width: 400
            })
        );
    }
    columns.push(
        createColumnInlineAttachment({
            title: () => i18n.global.t("model.attachment.modelName"),
            dataIndex: "",
            items,
            useForm,
            itemsKey,
            customKey: ({ itemIndex }) => `${itemsKey}.${itemIndex}.size`,
            customRenderInputProp: ({ key }) =>
                lodash.merge(
                    { disabled: viewOnly, group },
                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key } } })
                ),
            width: 200
        })
    );
    return columns;
};

export const initData = ({ props, data }) => {
    const { menuContext, viewOnly, itemsKey, canCreate, canDelete } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    data.columns = createColumns({ props, data });
    data.page = createPage({ data: items });
    data.tableOptions = { search: { activeKey: null } };
    data.manages = [
        createManageDelete({
            menuContext,
            visible: () => (viewOnly ? false : canDelete),
            onClick: ({ rowSelection }) => {
                onClickDeleteAllClient({ rowSelection, useForm, items, key: itemsKey });
                data.page.page = 0;
            },
            getCheckboxProps: ({ record }) => ({ disabled: record.attribute?.isDisabledDocumentName })
        }),
        createManageExportCsv({ menuContext })
    ];
    data.manageExtras = [
        {
            render: () => createButtonCreate({ onClick: () => items.push({}) }),
            visible: () => (viewOnly ? false : canCreate)
        }
    ];
    data.rowActions = [];
    fetchData({ props, data }).then(page => items.push(...page.data));
};

export const fetchData = ({ props }) => {
    const { fetchCriteria } = props;
    if (!fetchCriteria || fetchCriteria.fetched) {
        return Promise.resolve({ data: [] });
    }
    fetchCriteria.fetched = true;
    setIsLoading(true);
    return callSearch({ criteria: fetchCriteria }).finally(() => setIsLoading(false));
};
